import { Label } from '@/components/ui/label';

/**
 * SingleSelectCards — mobile-first card grid where exactly one option is selected.
 * options: [{ value, label, hint? }]
 */
export default function SingleSelectCards({ label, value, options, onChange, testIdPrefix, hint, error, columns = 2, required = false }) {
  const gridClass = columns === 1
    ? 'grid-cols-1'
    : columns === 3
    ? 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3'
    : 'grid-cols-1 sm:grid-cols-2';

  return (
    <div data-testid={`${testIdPrefix}-wrapper`}>
      {label && (
        <Label className="mb-2 block text-[15px] font-medium">
          {label}
          {required && (
            <>
              <span className="text-destructive ml-0.5" aria-hidden="true">*</span>
              <span className="sr-only"> (verplicht)</span>
              <span className="text-xs text-muted-foreground font-normal ml-2">(verplicht)</span>
            </>
          )}
        </Label>
      )}
      {hint && <p className="text-xs text-white/55 mb-3">{hint}</p>}
      <div className={`grid ${gridClass} gap-2`}>
        {options.map(opt => {
          const active = value === opt.value;
          return (
            <button
              type="button"
              key={opt.value}
              onClick={() => onChange(opt.value)}
              className={`text-left px-4 py-4 sm:py-3.5 rounded-xl border transition-all min-h-[60px] sm:min-h-[56px] active:scale-[0.99] ${
                active
                  ? 'border-emerald-400/70 bg-emerald-500/20 ring-2 ring-emerald-400/40'
                  : 'border-white/15 bg-white/[0.07] hover:bg-white/10 hover:border-emerald-400/40'
              } ${error ? 'border-rose-400/60' : ''}`}
              data-testid={`${testIdPrefix}-${opt.value}`}
              aria-pressed={active}
            >
              <div className="flex items-center gap-3">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-colors ${
                  active ? 'border-emerald-400' : 'border-white/35'
                }`}>
                  {active && <div className="w-2.5 h-2.5 rounded-full bg-emerald-400" />}
                </div>
                <div className="flex-1">
                  <div className="text-[15px] sm:text-sm font-medium text-white leading-snug">{opt.label}</div>
                  {opt.hint && <div className="text-xs text-white/55 mt-0.5">{opt.hint}</div>}
                </div>
              </div>
            </button>
          );
        })}
      </div>
      {error && <p className="text-xs text-rose-300 mt-1.5">{error}</p>}
    </div>
  );
}
